import { render, staticRenderFns } from "./OtpAuth.vue?vue&type=template&id=115b15db&scoped=true"
import script from "./OtpAuth.vue?vue&type=script&lang=js"
export * from "./OtpAuth.vue?vue&type=script&lang=js"
import style0 from "./OtpAuth.vue?vue&type=style&index=0&id=115b15db&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b15db",
  null
  
)

export default component.exports